//dependencias
import React, { Component } from 'react';

//componentes
import EvaluacionMAction from './evaluacionM'

class Index extends Component {

    render(){
        return(
            <div>
                <EvaluacionMAction />
            </div>
        );
    }

}
export default Index;